var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('base-stat',{attrs:{"title":_vm.title,"border-color":_vm.dataColor,"value":_vm.valueCalc}},[_c('template',{slot:"icon"},[_vm._t("icon")],2)],2)}
var staticRenderFns = []

export { render, staticRenderFns }